var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// import abstractions
import { TranslationsProvider, useTranslations } from './abstractions/contexts/TranslationsContext';
import { HeaderRoutesFooterLayout, LayoutWithRoutes, renderRoutes, } from './abstractions/routes/components';
import { ThemeProvider } from './abstractions/ThemeProvider';
// import atoms
import { BaseButton } from './components/atoms/BaseButton';
import { Formatter } from './components/atoms/Formatter';
import { Icon } from './components/atoms/Icon';
import { Line } from './components/atoms/Line';
import { Link } from './components/atoms/Link';
import { Logo } from './components/atoms/Logo';
import { NavigationSubItem } from './components/atoms/NavigationSubItem';
import { Portal } from './components/atoms/Portal';
import { RangeInput } from './components/atoms/RangeInput';
import { Spacer } from './components/atoms/Spacer';
import { TranslatedText } from './components/atoms/TranslatedText/TranslatedText';
import { Translation } from './components/atoms/Translation';
import { Typography } from './components/atoms/Typography';
// import layouts helpers
import { Column, Container, Row } from './components/layout/Container';
import { HeaderContentFooter } from './components/layout/HeaderContentFooter';
// import molecules
import { Button } from './components/molecules/Button';
import { Collapsible } from './components/molecules/Collapsible';
import { IconText } from './components/molecules/IconText';
import { Modal, PrimaryModal } from './components/molecules/Modal';
import { NavigationItem } from './components/molecules/NavigationItem';
import { PoweredBy } from './components/molecules/PoweredBy';
import { Select } from './components/molecules/Select';
import { SelectTags } from './components/molecules/SelectTags';
import { Tooltip } from './components/molecules/Tooltip';
//  import organisms
import { Chart } from './components/organisms/Chart';
import { Form, FormAlert, FormControlledRadioInputGroup, FormField, FormFieldArray, FormInput, FormRadioInputGroup, FormSelect, } from './components/organisms/Form';
import { Incentives } from './components/organisms/Incentives';
import { Navigation } from './components/organisms/Navigation';
import { Stepper } from './components/organisms/Stepper';
import { Table, TableArray, TableCell, TableRow } from './components/organisms/Table';
// import templates
import { ContentContainer } from './components/templates/ContentContainer';
import { ContentContext, ContentContextProvider } from './contexts/content';
// import contexts
import { DesignsContextProvider } from './contexts/designs';
import { PreloadsContext, PreloadsProvider } from './contexts/preloads';
import { FactoryComponent, FactoryContent, FactoryInstance } from './factory';
// import hocs
import withDesign from './hocs/withDesign';
// import hooks
import { useTranslation } from './abstractions/hooks/useTranslation';
import useDesign from './hooks/useDesign';
import useFormat from './hooks/useFormat';
import useMapValues from './hooks/useMapper';
import useWatch from './hooks/useWatch';
//import utils
import { getI18nInstance, i18nInitOptions, initI18n, } from './abstractions/hooks/useTranslationsResources';
import { mapValues, prepareAutoFormatConfig, prepareFormatConfig } from './utils/parsers';
import { runQuery } from './utils/query';
import { applyFormat, format, formatters } from './utils/strings';
export var atoms = {
    BaseButton: BaseButton,
    Icon: Icon,
    Line: Line,
    Link: Link,
    Logo: Logo,
    NavigationSubItem: NavigationSubItem,
    Portal: Portal,
    Spacer: Spacer,
    TranslatedText: TranslatedText,
    Translation: Translation,
    Typography: Typography,
    RangeInput: RangeInput,
    Formatter: Formatter,
};
export var layout = {
    Container: Container,
    Row: Row,
    Column: Column,
    HeaderContentFooter: HeaderContentFooter,
    HeaderRoutesFooterLayout: HeaderRoutesFooterLayout,
};
export var utils = {
    mapValues: mapValues,
    applyFormat: applyFormat,
    format: format,
    formatters: formatters,
    prepareAutoFormatConfig: prepareAutoFormatConfig,
    prepareFormatConfig: prepareFormatConfig,
    runQuery: runQuery,
    i18nInitOptions: i18nInitOptions,
    initI18n: initI18n,
    getI18nInstance: getI18nInstance,
};
export var molecules = {
    Button: Button,
    Modal: Modal,
    PrimaryModal: PrimaryModal,
    NavigationItem: NavigationItem,
    PoweredBy: PoweredBy,
    Select: Select,
    SelectTags: SelectTags,
    Stepper: Stepper,
    IconText: IconText,
    Tooltip: Tooltip,
    Collapsible: Collapsible,
};
export var organisms = {
    Navigation: Navigation,
    Select: Select,
    Form: Form,
    FormAlert: FormAlert,
    FormInput: FormInput,
    FormField: FormField,
    FormFieldArray: FormFieldArray,
    FormSelect: FormSelect,
    FormRadioInputGroup: FormRadioInputGroup,
    FormControlledRadioInputGroup: FormControlledRadioInputGroup,
    Table: Table,
    TableArray: TableArray,
    TableCell: TableCell,
    TableRow: TableRow,
    Chart: Chart,
    Incentives: Incentives,
};
export var templates = {
    ContentContainer: ContentContainer,
};
export var hooks = {
    useWatch: useWatch,
    useDesign: useDesign,
    useFormat: useFormat,
    useMapValues: useMapValues,
    useTranslation: useTranslation,
};
export var hocs = {
    withDesign: withDesign,
};
export var abstractions = {
    ThemeProvider: ThemeProvider,
    TranslationsProvider: TranslationsProvider,
    useTranslations: useTranslations,
    renderRoutes: renderRoutes,
    LayoutWithRoutes: LayoutWithRoutes,
};
export var contexts = {
    DesignsContextProvider: DesignsContextProvider,
    ContentContext: ContentContext,
    ContentContextProvider: ContentContextProvider,
    PreloadsContext: PreloadsContext,
    PreloadsProvider: PreloadsProvider,
};
var all = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, abstractions), atoms), layout), molecules), organisms), templates), contexts), hooks), hocs), utils), { FactoryContent: FactoryContent, FactoryInstance: FactoryInstance, FactoryComponent: FactoryComponent });
export default all;
